export default __webpack_public_path__ + "static/media/3.1ed4ed91.jpg";